// import
import AdminDashboard from "views/Dashboard/AdminDashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Profile from "views/Dashboard/Profile.js";
import Customers from "views/Dashboard/Customers.js";
import Personnels from "views/Dashboard/Personnels";
import Account from "views/Dashboard/Account.js";
import Services from "views/Dashboard/Services.js";
import PettyCash  from "views/Dashboard/PettyCash";
import EstimateOrder from "views/Dashboard/EstimateOrder";
import OrdersReport from "views/Dashboard/OrdersReport";
import MechanicsReport from "views/Dashboard/MechanicsReport";
import ProductArchives from "views/Dashboard/ProductArchives";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  ProfileIcon,
  SettingsIcon,
  DashboardLogo,
  WalletIcon,
  CartIcon,
} from "components/Icons/Icons";

import { FaArchive } from "react-icons/fa";

var dashRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   rtlName: "لوحة القيادة",
  //   icon: <HomeIcon color="inherit" />,
  //   component: AdminDashboard,
  //   layout: "/admin",
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: <HomeIcon color="inherit" />,
    component: AdminDashboard,
    layout: "/admin",
  },
  {
    path: "/estimate-order",
    name: "Estimate Order",
    rtlName: "لوحة القيادة",
    icon: <CartIcon color="inherit" />,
    component: EstimateOrder,
    layout: "/admin",
  },
  {
    path: "/orders-report",
    name: "Orders Report",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: OrdersReport,
    layout: "/admin",
  },
  {
    path: "/mechanics-report",
    name: "Mechanics Report",
    rtlName: "لوحة القيادة",
    icon: <StatsIcon color="inherit" />,
    component: MechanicsReport,
    layout: "/admin",
  },
  {
    path: "/services",
    name: "Services",
    rtlName: "لوحة القيادة",
    icon: <SupportIcon color="inherit" />,
    component: Services,
    layout: "/admin",
  },
  {
    path: "/customers",
    name: "Customers",
    rtlName: "لوحة القيادة",
    icon: <CreditIcon color="inherit" />,
    component: Customers,
    layout: "/admin",
  },
  {
    path: "/petty-cash",
    name: "Petty Cash",
    rtlName: "لوحة القيادة",
    icon: <WalletIcon color="inherit" />,
    component: PettyCash,
    layout: "/admin",
  },
  {
    path: "/personnels",
    name: "Personnels",
    rtlName: "لوحة القيادة",
    icon: <PersonIcon color="inherit" />,
    component: Personnels,
    layout: "/admin",
  },
  {
    path: "/inventory-archives",
    name: "Inventory Archives",
    rtlName: "لوحة القيادة",
    icon: <FaArchive color="inherit" />,
    component: ProductArchives,
    layout: "/admin",
  },
  {
    path: "/account",
    name: "Account",
    rtlName: "لوحة القيادة",
    icon: <SettingsIcon color="inherit" />,
    secondaryNavbar: true,
    component: Account,
    layout: "/admin",
  },
];
export default dashRoutes;
